// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"b23188a0","853":"9e5e750b","906":"fab7c5c9","945":"ceb616ae"}[chunkId] + ".chunk.js";
};